import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
const defaultLanguage = window.localStorage.getItem("rcml-lang") || "en";
export default function PhoneInputComponent(props) {
  const { error } = props;

  return (
    <>
      <div>
        <PhoneInput
          {...props}
          countryCodeEditable={false}
          style={{
            direction: defaultLanguage === "ar" ? "rtl" : "ltr",
          }}
          className={defaultLanguage === "ar" ? " tel-arabic" : ""}
        />
        {error ? (
          <p
            style={{
              paddingTop: 5,
              fontSize: 13,
              color: "red",
              textAlign: defaultLanguage === "ar" ? "right" : "left"
            }}
          >
            {error}
          </p>
        ) : null}
      </div>
    </>
  );
}
